module.exports = __webpack_public_path__ + "static/media/system.b586f70a.png";